module.exports = __webpack_public_path__ + "src/assets/img/icon_4.21f97ee7.svg";